import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
const apiUrl = `${urlPrefix}/UnitCase`
//#region 基本信息
const GetList = `${apiUrl}`
const GetStatusList = `${apiUrl}/GetStatus`
const GetWarningStatusList = `${apiUrl}/GetWarningStatus`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const ViewInfo = (id: number) => `${apiUrl}/view/${id}`
const PostData = `${apiUrl}`
const PutData = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
//#endregion

export const emptyCompany: UnitCaseCompanyData = {
    Id: 0,
    CaseId: 0,
    CompanyName: '',
    CreditCode: '',
    LegalPerson: '',
    ContactTel: '',
    Address: '',
    ZipCode: ''
}
export const emptyPersonal: UnitCasePersonalData = {
    Id: 0,
    CaseId: 0,
    FullName: '',
    Gender: 0,
    BirthDate: '',
    EducationId: 0,
    CertificateType: 0,
    CertificateNo: '',
    WorkUnit: '',
    Position: '',
    ContactTel: '',
    Address: '',
    ZipCode: '',
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    EducationName: '',
    CertificateTypeName: '',
    GenderName: ''
}
export const emptyData: UnitCaseData = {
    Id: 0,
    UnitId: 0,
    Cause: '',
    SourceId: 0,
    InvestigatId: 0,
    CrimeDate: new Date(),
    Lawman: '',
    Enforcement: '',
    Description: '',
    PartyType: 0,
    WarningStatus: 0,
    Status: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    UnitCode: '',
    UnitName: '',
    SourceName: '',
    InvestigatName: '',
    StatusText: '',
    WarningStatusText: '',

    AttachType: 0,
    AttachGuid: '',
    AttachPath: '',
    CompanyInfo: emptyCompany,
    PersonalInfo: emptyPersonal
}
export interface UnitCaseData {
    [key: string]: any
    Id: number
    UnitId: number
    Cause: string
    SourceId: number
    InvestigatId: number
    CrimeDate: Date
    Lawman: string
    Enforcement: string
    Description: string
    PartyType: number
    WarningStatus: number
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    UnitCode: string
    UnitName: string
    SourceName: string
    InvestigatName: string
    StatusText: string
    WarningStatusText: string

    AttachType: number
    AttachGuid: string
    AttachPath: string
    CompanyInfo: UnitCaseCompanyData
    PersonalInfo: UnitCasePersonalData
}
export interface UnitCaseCompanyData {
    [key: string]: any
    Id: number
    CaseId: number
    CompanyName: string
    CreditCode: string
    LegalPerson: string
    ContactTel: string
    Address: string
    ZipCode: string
}
export interface UnitCasePersonalData {
    [key: string]: any
    Id: number
    CaseId: number
    FullName: string
    Gender: number
    BirthDate: string
    EducationId: number
    CertificateType: number
    CertificateNo: string
    WorkUnit: string
    Position: string
    ContactTel: string
    Address: string
    ZipCode: string

    EducationName: string
    CertificateTypeName: string
    GenderName: string
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const getStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStatusList,
        params: { type: firstType }
    })
}
export const getWarningStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetWarningStatusList,
        params: { type: firstType }
    })
}
export const getList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}
export const viewInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: ViewInfo(id),
    })
}
export const postData = (form: UnitCaseData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
export const putData = (id: number, form: UnitCaseData) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}
